/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_After_EndInputs */



/**
* | output |
* | --- |
* | "The start date must be before the end date" |
*
* @param {Start_After_EndInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const start_after_end = /** @type {((inputs?: Start_After_EndInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_After_EndInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The start date must be before the end date")
	return /** @type {LocalizedString} */ ("La date de début doit être antérieure à la date de fin")
});